import { useEffect, useState } from "react";
import { fetchOrders } from "../api";
import OrderCard from "./OrderCard";

const OrderList = () => {
  const [orders, setOrders] = useState([]);
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    const getOrders = async () => {
      const data = await fetchOrders();
      setOrders(data);
    };
    getOrders();

    const ws = new WebSocket("wss://api.ipk-test.com.ua/ws/update-order-status/");
    setSocket(ws);

    return () => ws.close();
  }, []);

  return (
    <div>
      <h2>Список замовлень</h2>
      {orders.length > 0 ? (
        orders.map((order) => <OrderCard key={order.id} order={order} socket={socket} />)
      ) : (
        <p>Замовлень поки немає...</p>
      )}
    </div>
  );
};

export default OrderList;